module.exports = __webpack_public_path__ + "img/hydt_4.98fb8f64.png";